module.exports = __webpack_public_path__ + "img/w3_cloud_white.92d03e50.png";